import { Text } from '@wix/design-system';
import React from 'react';
import { useIsStudioNewUi } from '../../../hooks';
import { useCurrentModule } from '../../ModuleProvider';
import styles from '../RevShare.scss';
export const RevShareCycleSubtitle = _ref => {
  let {
    formattedAmount
  } = _ref;
  const module = useCurrentModule();
  const {
    Trans
  } = module.internals.useTranslations();
  const isStudioNewUi = useIsStudioNewUi();
  React.useEffect(() => {
    module.internals.bi.onRevshareSubtitleLoad == null || module.internals.bi.onRevshareSubtitleLoad({});
  }, []);
  return /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "studio_package_picker.header.billing_cycle.revshare.subtitle",
    components: {
      strong: /*#__PURE__*/React.createElement(Text, {
        weight: "bold",
        className: isStudioNewUi ? styles.newUiRevShareAmount : styles.revShareAmount
      })
    },
    values: {
      amountEarned: formattedAmount
    }
  }));
};
//# sourceMappingURL=RevShareCycleSubtitle.js.map